import React from 'react';
import { AuthData } from '../../../context/auth';
import {
	RenewalData,
	withRenewalContext,
} from '../../../context/RenewalProvider';
import { Exposure as ExposureType } from '../../../types/policy';
import AddedExposureDetails from './AddedExposureDetails';
import ExistingExposureDetails from './ExistingExposureDetails';

interface Props {
	authData: AuthData;
	renewalData: RenewalData;
}

/**
 * The component to render an existing or added exposure detail on an renewal.
 */
const Exposure = (props: Props) => {
	const { selectedExposure } = props.renewalData;
	const exposureIsExisting = !!(selectedExposure as ExposureType).displayId;

	if (exposureIsExisting) {
		return <ExistingExposureDetails />;
	} else {
		// exposure was added, meaning perils will all be PerilCreateRequests
		return <AddedExposureDetails />;
	}
};

export default withRenewalContext<Props>(Exposure);
